export interface IArgs {
    current: boolean;
}

export const query = `
    query($current:Boolean) {
        messages(current:$current) {
            id
            datetime
            senderName
            read
            archived
            subject
            content
            canReply
            replyTo {
                id
                senderName
                subject
                content
            }
        }
    }
`;

export interface IMessage {
    id: string;
    datetime: string;
    senderName: string;
    read: boolean;
    archived: boolean;
    subject: string;
    content: string;
    canReply: boolean;
    replyTo: {
        id: string;
        senderName: string;
        subject: string;
        content: string;
    } | null;
}

export interface IData {
    messages: IMessage[];
}

export const sentQuery = `
    query {
        learningCoachMessageList {
            id
            datetime
            subject
            content
        }
    }
`;

export interface ISentMessage {
    id: string;
    datetime: string;
    subject: string;
    content: string;
}

export interface ISentData {
    learningCoachMessageList: ISentMessage[];
}